import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ITitleConfiguration, ITitleProps } from '../models';
import { query } from '@kurtosys/ksys-app-template';
import { FundManagerStoreBase } from '../../../common/FundManagerStoreBase';

export class TitleStore extends FundManagerStoreBase {
	static componentKey: 'title' = 'title';

	@computed
	get configuration(): ITitleConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(TitleStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@computed
	get titleProps(): ITitleProps | undefined {
		const { queryStore } = this.storeContext;

		if (queryStore) {
			const titleConfiguration = this.configuration;
			if (titleConfiguration) {
				const titleValues = this.mergeQueriesAndProps(titleConfiguration) as ITitleConfiguration['props'];

				if (titleValues) {
					return { title: titleValues.value };
				}
			}
		}
		return;
	}
}